import type { ReactNode } from 'react'
import styles from './StatTile.module.css'

export interface StatTileProps {
  label: string
  /** `null` = source not connected → shows "—" and a caption; never a made-up number. */
  value: ReactNode | null
  caption?: ReactNode
  tone?: 'default' | 'primary' | 'event' | 'up' | 'down'
  loading?: boolean
}

export function StatTile({ label, value, caption, tone = 'default', loading = false }: StatTileProps) {
  return (
    <div className={styles.tile} aria-busy={loading || undefined}>
      <span className={styles.label}>{label}</span>
      {loading ? (
        <span className={styles.skeleton} aria-hidden="true" />
      ) : (
        <span className={`${styles.value} ${value === null ? styles.none : styles[tone]}`}>{value === null ? '—' : value}</span>
      )}
      {loading ? <span className="sr-only">Loading {label}</span> : value === null ? (
        <span className={styles.caption}>Data not connected</span>
      ) : caption ? <span className={styles.caption}>{caption}</span> : null}
    </div>
  )
}
